module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAsUlEQVRYR+2XMQ7CMAxFvxkYEZyDK5SrwA1goodgohwBiQ5cLl1gaZyPklRqJ7YSBg+W42Twz9ue8Lldwq8uoO4BvwEVgCL1VGHS43laHGYCId7H+XsxvzuS98W7r4VtdQX0lBf7vGz+ACBSkEbY7hzg14UCdDEAx5//nAAsgBEwAkbACBgBI2AEjIARMAJG4C8IlFQzJ3xUDUSPRdww8CajnvsDoIOkzqznYJf0/NWfP7CE2cGD1iWCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/flightDetail/endHoverImg.png
// module id = VKMN
// module chunks = 2